<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base">
                        <div class="flex">
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.Name')" :placeholder="$t('Labels.Name')" v-model="data.name" @keydown.space.prevent/>
                          </div>
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.Description')" :placeholder="$t('Labels.Description')" v-model="data.description"/>
                          </div>
                        </div>
                        <div class="flex">
                          <div  class="flex-1 p-2">
                            <label>{{$t('Labels.Profile')}}</label>
                            <v-select :options="profiles" v-model="data.service_profile_uuid" :reduce="profile => profile.id" label="name"/>
                          </div>
                          <div class="w-1/2 p-2">
                            <label>{{$t('Labels.Organization')}}</label>
                            <v-select :options="organizations" v-model="data.organization_id" :reduce="org => org.id" label="name"/>
                          </div>
                        </div>
                        <div class="text-right">
                            <vs-button @click="requestPassword()" class="bg-primary mt-4" type="filled" :disabled="!valid">{{$t("Labels.Save")}}</vs-button>
                        </div>
                    </vx-card>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    vSelect,
    Datepicker
  },

  data () {
    return {
      profiles: [],
      organizations: [],
      uuid:this.$route.params.uuid, 
      data:{
        service_profile_uuid: '',
        organization_id: '',
        id_nw:'',
        name: '',
        description: ''
      }
    }
  },

  methods: {
    async getCompanies () {
      this.$vs.loading()

      const params = {
        url: 'organizations',
        method: 'GET',
        params:{}
      }
      await request(params).then(response => {
        this.organizations = response.data.data.result
      }).finally(() => {
        this.getProfiles()
      })                        
    },
    async getProfiles () {
      this.$vs.loading()

      const params = {
        url: 'service_profiles',
        method: 'GET',
        params:{}
      }
      await request(params).then(response => {
        this.profiles = response.data.data.result
      }).finally(() => {
        this.getData()
      })                        
    },
    async getData () {
      const params = {
        url: `applications/${this.uuid}`,
        method: 'GET',
        params: {
          limit: 0
        }
      }
      await request(params).then(response => {
        this.data = response.data.data
        this.$vs.loading.close()
      })
    },
    requestPassword () {
      globalPassActions.show()
    },
    async update () {
      const params = {
        url: `applications/${this.uuid}`,
        method: 'PUT',
        params: this.data
      }
      await request(params).then(response => {
        window.location.href = `/apps/${this.uuid}`
      })  
    }
  },
  created () {
    this.getCompanies()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    },
    valid () {
      if (this.data.service_profile_uuid != 0 && this.data.organization_id != 0 && !empty(this.data.name) && !empty(this.data.description)) return true
      else return false
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.update()
    }
  }
}
</script>
